import ServicesList from './views/services-list.c';
export default ServicesList;
